<!--
 * @Description: 项目执行流程
 * @Date: 2024-01-11 13:52:40
-->
<template>
  <div class="bi-tmpl-detail__right__cmpt">
    <div>
      <span v-if="curItem.tips" class="bi-tmpl-detail__right__cmpt__tips">
        {{ curItem.tips }}
      </span>
    </div>
    <div v-for="(item, index) in TYPE_MAPPING" :key="index">
      <div class="xrk-card" style="width: 420px; height: 600px">
        <div style="box-sizing: border-box; padding: 0 20px">
          <component
            v-if="titleCmpt"
            :is="titleCmpt"
            style="
              width: 1200px;
              transform: scale(0.33);
              transform-origin: 0 center;
            "
            v-bind="{
              innerText: '项目执行流程',
              enInnerText: 'Project Implementation Process',
              index: 9
            }"
          />

          <component
            style="width: 100%; height: 100%"
            :is="cmpName(item.value)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';
import PcModuleAge from '../bi-pc-module/pc-module-process/index';

const TYPE_MAPPING = [1].map(i => {
  return {
    value: 'pc-module-process-' + i,
    index: i
  };
});

const cmpName = name => {
  return PcModuleAge.filter(comp => comp.__name === name)[0];
};

const { curItem, titleCmpt } = useDetailCmpt({});
</script>
<style lang="scss" scope></style>
